import './context-menu-modal.scss';

import { faBroadcastTower, faEraser, faFlag, faFlagUsa } from '@fortawesome/free-solid-svg-icons';
import { BModal } from 'bootstrap-vue';
import { defineComponent } from 'vue';

import { OfflineDataFetcher, OfflineDataUpdateCacher } from '@skinsoft/offline';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { ForceSwReloadModal } from '@skinsoft/offline-mode'

declare var COMMIT_HASH: string;
declare var BRANCH: string;
declare var BUILD_ISO_DATE: string;
declare var VERSION: string;

export const ContextMenuModal = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./context-menu-modal.html'),
    components: {
        sForceSwReloadModal: ForceSwReloadModal,
    },
    data() {
        return {
            broadcastTowerIcon: faBroadcastTower,
            eraserIcon: faEraser,
            flagIcon: faFlag,
            flagUsaIcon: faFlagUsa,

            branch: BRANCH,
            buildDate: new Date(BUILD_ISO_DATE),
            commitHash: COMMIT_HASH,
            version: VERSION,
        }
    },
    computed: {
        showBranch(): boolean {
            if(BRANCH && (BRANCH.toLowerCase() === 'head' || BRANCH.toLowerCase() === 'prerelease') ) {
                return false
            }

            return true
        },
    },
    methods: {
        isLocaleOverriden() {
            return !!window.localStorage.getItem('locale');
        },
        close() {
            (this.$refs.modal as BModal).hide();
        },
        open() {
            (this.$refs.modal as BModal).show();
        },
        checkForUpdate() {
            this.emitOnBus('check_for_update_topic');
            this.close();
        },
        async clearCache() {
            await OfflineDataFetcher.clear()
            await OfflineDataUpdateCacher.clear()
            this.close();
        },
        async overrideLocaleWithEnglish() {
            window.localStorage.setItem('locale', 'en');
            // @ts-ignore
            window.location.reload(true);
        },
        async resetLocaleOverride() {
            window.localStorage.removeItem('locale');
            // @ts-ignore
            window.location.reload(true);
        },
        openSwReloadModal () {
            (this.$refs.swModal as InstanceType<typeof ForceSwReloadModal>).openModal()
        },
    },
})
